import { styled, TextField } from "@mui/material";

export const Styled = {
    TextField: styled(TextField)`
        & .MuiInputBase-root.MuiInputBase-root > input {
            padding: 6px 8px;
            font-size: 14px;
        }
    `,
};
